<template>
  <v-btn text  v-if="isCurrentUserLoaded"  >
    <v-icon class="pr-1" >mdi-account-box</v-icon>
    {{currentUser.name}}
  </v-btn>
</template>

<script>


export default {
  name: 'CurrentUser',
  beforeCreate() {
    this.$store.dispatch('navigation/isCurrentUserDataLoaded')
    },
  data(){
    return{
      name: ''
    }
  },
  watch:{
    currentUser(newVal){
      if(newVal && this.$ml.lang != newVal.language) {
        this.$ml.change(newVal.language);
        this.$cookies.set('lang', newVal.language);
      }
    }
  },
  computed:{
    isCurrentUserLoaded(){
      return this.$store.getters['navigation/isCurrentUserDataLoaded']
    },
    currentUser(){
      return !!this.$store.getters['user/authUserInfo'] ? this.$store.getters['user/authUserInfo'] :{name:''}
    },
  }
}
</script>

<style scoped>

</style>
